import React, { useContext } from "react";
import { DiscoveryContext } from "../discovery-context";
import { Box, Card, CardContent, Typography, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import MUIButton from "../../../Component/UI/MUIButton/MUIButton";
import classes from "./SelectedComponent.module.css";
import DownloadIcon from "@mui/icons-material/Download"; // example icon
import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

const SelectedComponent = ({ generateReport, loading }) => {
  const discoveryCtx = useContext(DiscoveryContext);
  const SelectedSection = Object.values(discoveryCtx.state.selectedSection);

  const containerRef = useRef(null);

  const scroll = (direction) => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: direction === "left" ? -250 : 250, // adjust scroll distance
        behavior: "smooth",
      });
    }
  };

  const handleDelete = (uniqueKey) => {
    discoveryCtx.clickComponentCheckbox({ uniqueKey, checked: true });
  };

  const selectReportSection = () => {
    discoveryCtx.cancelSelection();
  };

  console.log("SelectedSection....", SelectedSection);

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        height: "160px",
        boxShadow: 3,
        borderRadius: 3,
        p: 1,
        display: "flex",
        alignItems: "center",
        gap: 2,
        zIndex: 50,
      }}
      className={classes.card}
    >
      {/* Left scroll button */}
      {SelectedSection.length > 3 && (
        <IconButton
          onClick={() => scroll("left")}
          sx={{ flexShrink: 0, color: "white" }}
          className={classes.buttonHover}
        >
          <ChevronLeft />
        </IconButton>
      )}

      {/* Cards container */}
      <div
        ref={containerRef}
        style={{
          display: "flex",
          gap: 12,
          height: "100%",
          flex: 1,
          alignItems: "center",
          overflowX: "auto",
          overflowY: "hidden",
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE
        }}
      >
        {SelectedSection.length ? (
          SelectedSection.map(
            (
              { title, uniqueKey, llm, category, market, competitor },
              index
            ) => {
              const object = { llm, category, market, competitor };
              const filterOption = Object.entries(object).filter(
                (ele) => ele[1]
              );

              return (
                <Card
                  key={uniqueKey}
                  sx={{
                    height: "95%",
                    padding: "2px",
                    aspectRatio: 1.5,
                    position: "relative",
                    flexShrink: 0,
                    backgroundColor: "#E3F2FD",
                    borderRadius: 2,
                    borderLeft: "6px solid #007BFF",

                    "&:hover .delete-btn": { opacity: 1 },
                  }}
                >
                  <CardContent
                    sx={{
                      textAlign: "start",
                      fontSize: ".9rem",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      padding: "2px",
                    }}
                  >
                    {" "}
                    <div>
                      <span title={title} className={classes.text}>
                        {title}
                      </span>
                    </div>
                    {filterOption.map((filter) => (
                      <div>
                        <span className={classes.sub_text} title={filter[1]}>
                          {filter[1]}
                        </span>{" "}
                      </div>
                    ))}{" "}
                    <div
                      style={{
                        justifyContent: "center",
                        fontWeight: "bold",
                        flex: 1,
                        alignItems: "flex-end",
                        display: "flex",
                        fontSize: ".8rem",
                      }}
                    >
                      {" "}
                      {index + 1}{" "}
                    </div>{" "}
                  </CardContent>

                  {/* <div
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                      style={{
                                                        opacity: item.is_active ? 1 : 0.5,
                                                        background: item.is_active
                                                          ? "#E3F2FD"
                                                          : "#F5F5F5",
                                                        borderLeft: item.is_active
                                                          ? "4px solid #007BFF"
                                                          : "4px solid #B0BEC5",
                                                        ...provided.draggableProps.style, // Ensures smooth dragging
                                                      }}
                                                      className={classes.each_subrow}
                                                      onClick={() =>
                                                        handleEnableDisable(id, item.id)
                                                      }
                                                    >
                                                      <ListItemText
                                                        primary={item.name}
                                                        primaryTypographyProps={{
                                                          variant: "caption",
                                                        }}
                                                      />
                                                      {item.generate_summary !== undefined && (
                                                        <div onClick={(e) => e.stopPropagation()}>
                                                          <Typography
                                                            variant="caption"
                                                            style={{
                                                              fontSize: "10px",
                                                              color: "grey",
                                                            }}
                                                          >
                                                            Summary:
                                                          </Typography>
                                                          <Switch
                                                            size="small"
                                                            sx={{ transform: "scale(0.8)" }}
                                                            checked={item.generate_summary}
                                                            onChange={(e) => {
                                                              e.stopPropagation();
                                                              handleSwitchChange(id, item.id);
                                                            }}
                                                          />
                                                        </div>
                                                      )}
                                                    
                                                    </div> */}
                  <IconButton
                    className="delete-btn"
                    size="small"
                    onClick={() => handleDelete(uniqueKey)}
                    sx={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      bgcolor: "error.main",
                      color: "white",
                      opacity: 0,
                      transition: "opacity 0.3s",
                      "&:hover": { bgcolor: "error.dark" },
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Card>
              );
            }
          )
        ) : (
          <h3 style={{ color: "#3ad5cc" }}>
            {" "}
            Please select the widgets you want to include in the screenshot.{" "}
          </h3>
        )}
      </div>

      {/* Right scroll button */}
      {SelectedSection.length > 3 && (
        <IconButton
          onClick={() => scroll("right")}
          sx={{ flexShrink: 0, color: "white" }}
          className={classes.buttonHover}
        >
          <ChevronRight />
        </IconButton>
      )}

      {/* Action buttons */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 5,
          marginLeft: 10,
        }}
      >
        <MUIButton
          onClick={() => generateReport("brand-audit-checkbox")}
          loading={loading}
          startIcon={<DownloadIcon />}
        >
          Export Report
        </MUIButton>
        <MUIButton onClick={selectReportSection}>Cancel</MUIButton>
      </div>
    </Box>
  );
};

export default SelectedComponent;
